export const LoadBoardTypesEnum = {
    SHIP_CARS: 1,
    SUPER_DISPATCH: 2
};

export const LoadBoardTypesList = [
    { id: LoadBoardTypesEnum.SHIP_CARS, name: "ShipCars" },
    { id: LoadBoardTypesEnum.SUPER_DISPATCH, name: "SuperDispatch" }
];
